export const DVTJCUVConnectCddEmpParentTabs = {
    PRIORITY_PROCESS_TAB: { title: 'ƯU TIÊN XỬ LÝ', id: 'dvtjcuv-connect-cdd-emp-priority-process-tab' },
    NEW_CDDS_TAB: { title: '1-NEW CDDS', id: 'dvtjcuv-connect-cdd-emp-new-cdds-tab' },
    BRIEF_SENT_TAB: { title: '2-BRIEF SENT', id: 'dvtjcuv-connect-cdd-emp-brief-sent-tab' },
    FU_RECEIVERS_TAB: { title: '3-FU RECEIVERS', id: 'dvtjcuv-connect-cdd-emp-fu-receivers-tab' },
    CALL_CHAT_DN_REC_UPD_INF: { title: '4-Call Chat ĐN RECEIVER UPDATE INFO', id: 'dvtjcuv-connect-cdd-emp-call-chat-dn-rec-upd-inf-tab', hide: true },
    SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB: { title: '5-Gửi Email ĐN RECEIVER UPDATE INFO', id: 'dvtjcuv-connect-cdd-emp-send-email-receiver-update-info-tab', hide: true },
    PAYMENT_AND_WARRANTY_TAB: { title: '4-TTOAN & BHANH', id: 'dvtjcuv-connect-cdd-emp-payment-and-warranty-tab' },
};


export const DVTJCUVConnectCddEmpBriefSentTabs = {
    OFFERING_TAB: { title: '2.1-Offering', id: 'offering-tab' },
    INTERVIEWING_TAB: { title: '2.2-Interviewing', id: 'interviewing-tab' },
    CV_SENT_TAB: { title: '2.3-CV sent', id: 'cv-sent-tab' },
    EMP_SHARED_JOB_TAB: { title: '2.4-Emp shared job', id: 'emp-shared-job-tab' },
    NEED_TO_FIND_MORE_EMP_TAB: { title: '2.5-Need to Find more Emp', id: 'need-to-find-more-emp-tab' },
    OTHERS_TAB: { title: '2.6-Others', id: 'others-tab' }
};


export const DVTJCUVConnectCddFUReceiverTabs = {
    RECEIVER_LIST_NEED_FU_TAB: { title: '3.1-List Receivers cần FU', id: 'dvtjcuv-connect-cdd-emp-fu-receivers-need-fu-tab' },
    SEND_EMAIL_TAB: { title: '3.2-Gửi email', id: 'dvtjcuv-connect-cdd-emp-fu-receivers-send-email-tab' },
};

export const DVTJCUVConnectCddSendEmailTabs = {
    DRAFT_TAB: { title: '5.2.1-Duyệt Draft & Gửi email', id: 'draft-tab' },
    NOT_PERMISSION_EMAIL_TAB: { title: '5.2.2-Person bạn chưa có quyền gửi email', id: 'not-permission-email-tab' },
    NEED_CHECKING_TAB: { title: '5.2.3-Person need checking', id: 'need-checking-tab' },
    NEED_INPUT_INFO_TAB: { title: '5.2.4-Person cần nhập bổ sung ttin', id: 'need-input-info-tab' },
    SEND_WHEN_UNLIMITED_TAB: { title: '5.2.5-Person chờ hạn mức', id: 'send-when-unlimited-tab' },
    EXPORTED_WAITING_SEND_EMAIL_RECEIVER_UPDATE_INFO_TAB: { title: '5.2.6-UV đã export, chờ NL Gửi email Đề nghị Receiver update info', id: 'exported-waiting-send-email-tab' }
};

export const DVTJCUVConnectCddSendEmailReceiverUpdateInfoTabs = {
    RECEIVER_LIST_TAB: { title: '5.1-List Receivers', id: 'email-dn_update-info-receiver-list-tab' },
    SEND_EMAIL_TAB: { title: '5.2-Gửi email', id: 'email-dn_update-info-send-email-tab', childTabs: DVTJCUVConnectCddSendEmailTabs },
    // FOLLOW_UP_TAB: {title: '4.3-FU', id: 'email-dn_update-info-follow-up-tab'}
};

export const DVTJCUVConnectCddFUReceiverSendEmailTabs = {
    DRAFT_TAB: { title: '3.2.1-Duyệt Draft', id: 'draft-tab' },
    NOT_PERMISSION_EMAIL_TAB: { title: '3.2.2-Person bạn chưa có quyền gửi email', id: 'not-permission-email-tab' },
    NEED_CHECKING_TAB: { title: '3.2.3-Person need checking', id: 'need-checking-tab' },
    NEED_INPUT_INFO_TAB: { title: '3.2.4-Person cần nhập bổ sung ttin', id: 'need-input-info-tab' },
    SEND_WHEN_UNLIMITED_TAB: { title: '3.2.5-Person chờ hạn mức', id: 'send-when-unlimited-tab' },
    EXPORTED_WAITING_SEND_EMAIL_TAB: { title: '3.2.6-UV đã export', id: 'exported-waiting-send-email-tab' }
};

